import type { AiCapabilityPage } from "../schema.js";
import { BOUND, OWNER_ADMIN } from "./_shared.js";

/**
 * `MEMBER-BIRTH-DATE` (@UC0216 · @UC0055, QĐ người dùng 18/10/2026) — trang **redirect**: chat KHÔNG hỏi ô, KHÔNG có nút Đồng ý, chỉ một
 * câu giải thích + nút mở tab "Thành viên" (`/groups/:groupId/members`) — sửa ngày sinh ở màn Chi tiết thành viên, chạm ô "Ngày sinh".
 * Cửa mobile trang này chịu trách nhiệm: `PATCH .../birth-date` (chủ nhóm / quản trị viên, suất con nhóm phụ huynh).
 * Cùng vai với route (`OWNER_ADMIN`) — thủ quỹ / thành viên không thấy lối sửa ở màn đích. `BOUND`: chưa có eval đo nên chưa `live`.
 */
export const MEMBER_BIRTH_DATE = {
  id: "MEMBER-BIRTH-DATE",
  uc: "@UC0216",
  tier: "redirect",
  status: BOUND,
  roles: OWNER_ADMIN,
  flags: [],
  slots: [],
  llm: {
    description: "Sửa hoặc thêm NGÀY SINH của một học sinh (suất con) trong nhóm phụ huynh. KHÔNG phải đổi tên.",
    examples: [
      "sửa ngày sinh của bé",
      "sua ngay sinh cua be",
      "ngày sinh bé An ghi sai, sửa lại",
      "ngay sinh be An ghi sai sua lai",
      "thêm ngày sinh cho học sinh",
      "them ngay sinh cho hoc sinh",
    ],
  },
  screen: "/groups/:groupId/members",
  screenShows: "member_birth_date",
  endpoints: ["PATCH /groups/{groupId}/members/{memberId}/birth-date"],
  facts: [],
  templates: {
    redirect: "Mình mở trang thành viên để bạn sửa ngày sinh nhé — chọn bé rồi chạm vào ô Ngày sinh.",
  },
  journey: { after: [] },
  help: { title: "Sửa ngày sinh học sinh", tryNow: "sửa ngày sinh của bé" },
} satisfies AiCapabilityPage;
